module.exports = __webpack_public_path__ + "assets/img/home1.f4b0d995.png";